
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order/shipment",
      function () {
        return require("private-next-pages/order/shipment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order/shipment"])
      });
    }
  